import { FC } from 'react';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface EditFields {
  fullName: string;
  firstName: string;
  lastName: string;
  phone: string;
  jobTitle: string;
  status: string;
  notes: string;
}

interface ContactEditFormProps {
  editFields: EditFields;
  setEditFields: (fields: EditFields) => void;
  onSave: () => void;
  onCancel: () => void;
  isSaving: boolean;
}

const ContactEditForm: FC<ContactEditFormProps> = ({
  editFields,
  setEditFields,
  onSave,
  onCancel,
  isSaving,
}) => {
  return (
    <div className="space-y-4">
      <div>
        <label className="text-xs font-medium text-slate-600 mb-1.5 block">
          Full Name
        </label>
        <Input
          value={editFields.fullName}
          onChange={(e) => setEditFields({ ...editFields, fullName: e.target.value })}
          placeholder="Full name"
          className="h-9"
        />
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="text-xs font-medium text-slate-600 mb-1.5 block">
            First Name
          </label>
          <Input
            value={editFields.firstName}
            onChange={(e) => setEditFields({ ...editFields, firstName: e.target.value })}
            placeholder="First name"
            className="h-9"
          />
        </div>
        <div>
          <label className="text-xs font-medium text-slate-600 mb-1.5 block">
            Last Name
          </label>
          <Input
            value={editFields.lastName}
            onChange={(e) => setEditFields({ ...editFields, lastName: e.target.value })}
            placeholder="Last name"
            className="h-9"
          />
        </div>
      </div>

      <div>
        <label className="text-xs font-medium text-slate-600 mb-1.5 block">
          Phone Number
        </label>
        <Input
          value={editFields.phone}
          onChange={(e) => setEditFields({ ...editFields, phone: e.target.value })}
          placeholder="Phone number"
          className="h-9"
        />
      </div>

      <div>
        <label className="text-xs font-medium text-slate-600 mb-1.5 block">
          Job Title
        </label>
        <Input
          value={editFields.jobTitle}
          onChange={(e) => setEditFields({ ...editFields, jobTitle: e.target.value })}
          placeholder="Job title"
          className="h-9"
        />
      </div>

      <div>
        <label className="text-xs font-medium text-slate-600 mb-1.5 block">
          Status
        </label>
        <Select
          value={editFields.status}
          onValueChange={(value) => setEditFields({ ...editFields, status: value })}
        >
          <SelectTrigger className="h-9">
            <SelectValue placeholder="Select status" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="new">New</SelectItem>
            <SelectItem value="contacted">Contacted</SelectItem>
            <SelectItem value="qualified">Qualified</SelectItem>
            <SelectItem value="converted">Converted</SelectItem>
            <SelectItem value="lost">Lost</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div>
        <label className="text-xs font-medium text-slate-600 mb-1.5 block">
          Notes
        </label>
        <Textarea
          value={editFields.notes}
          onChange={(e) => setEditFields({ ...editFields, notes: e.target.value })}
          placeholder="Add notes..."
          rows={4}
          className="resize-none"
        />
      </div>

      <div className="flex gap-2 pt-2">
        <Button size="sm" onClick={onSave} disabled={isSaving} className="flex-1">
          {isSaving ? 'Saving...' : 'Save Changes'}
        </Button>
        <Button size="sm" variant="outline" onClick={onCancel} className="flex-1">
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default ContactEditForm;
